import { Link, useLocation, useHistory } from "react-router-dom";
import React, { useContext } from "react";
import { ThemeContext } from "../../../context/theme/ThemeContext";
import Language from "../../../i18n/english.json";


function Index(props) {
  const { theme, changeTheme } = useContext(ThemeContext);
  return (
    <div className="card p-4 m-0 bg-white">
      <div className="d-flex flex-row align-items-center justify-content-between w-100">
        <h4 className="h4">Welcome to {Language?.app_name}</h4>
        {/* <button className="btn btn-sm btn-danger mx-4">close</button> */}
      </div>
      <div className="d-flex flex-row align-items-center  my-3">
        <dd>
          Thank you for registering. It is necessary you update your profile,
          <br /> click the button below to update your profile
        </dd>
      </div>
      <Link to={"/student/profile"}>
        <button className="mc-btn btn-style-2">Update Profile</button>
      </Link>
    </div>
  );
}

export default Index;
